import { useMemo } from 'react'
import { useLocales } from '@sevenrooms/locales'
import { usePriorityAlertsRequests } from '../../hooks'
import { reservationWidgetMessages } from '../../reservationWidgetMessages'
import { AlertMeButton } from '../PrimaryAvailability/AlertMeButton'
import { SubmitARequestButton } from '../PrimaryAvailability/SubmitARequestButton'

export interface RequestButtonProps {
  isPrivateEvent?: boolean
  buttonVariant?: 'primary' | 'secondary' | 'tertiary'
  partySize: number
  onRequestButtonClick?: () => void
  onPriorityAlertButtonClick?: () => void
}

export function RequestOrPriorityAlertButton({
  isPrivateEvent,
  buttonVariant = 'primary',
  partySize,
  onRequestButtonClick,
  onPriorityAlertButtonClick,
}: RequestButtonProps) {
  const { formatMessage } = useLocales()
  const [priorityAlertsEnabled, requestEnabled] = usePriorityAlertsRequests({ partySize, requestsOnly: !!isPrivateEvent })

  const buttonWidth = useMemo(() => {
    if (buttonVariant === 'primary') {
      return '240px'
    }
    if (buttonVariant === 'secondary') {
      return '100%'
    }
    return 'initial'
  }, [buttonVariant])

  const buttonSize = useMemo(() => (buttonVariant === 'primary' ? 'm' : 'l'), [buttonVariant])
  if (!priorityAlertsEnabled && !requestEnabled) {
    return null
  }

  if (priorityAlertsEnabled) {
    return <AlertMeButton onClick={() => onPriorityAlertButtonClick?.()} size={buttonSize} variant={buttonVariant} width={buttonWidth} />
  }

  if (requestEnabled) {
    return (
      <SubmitARequestButton
        data-test={isPrivateEvent ? 'sr-contact-us-button' : undefined}
        title={isPrivateEvent ? formatMessage(reservationWidgetMessages.resWidgetPrivateEventsContactUsLabel) : undefined}
        onClick={() => onRequestButtonClick?.()}
        size={buttonSize}
        variant={buttonVariant}
        width={buttonWidth}
      />
    )
  }

  return null
}
